import { useQuery } from "react-query";
import axios from "axios";
import { toast } from "react-toastify";
import { SelectionListItem } from "../../../../../Forms/SelectionListItem";
import { minutesAsMilliSeconds } from "../../../../../Utils/time";
import { ttProtectionIeoPlantsQueryKey } from "../ttProtectionQueryKey";

type FetchIeoPlantsForPlantGsdbsProps = {
  plantGsdbs: string[];
  url: string;
};

export const useFetchIeoPlantsForPlantGsdbs = ({
  url,
  plantGsdbs,
}: FetchIeoPlantsForPlantGsdbsProps) => {
  return useQuery<SelectionListItem<string>[], Error>({
    queryKey: ttProtectionIeoPlantsQueryKey,
    staleTime: minutesAsMilliSeconds(10),
    cacheTime: minutesAsMilliSeconds(20),
    queryFn: () => fetchIeoPlants({ url, plantGsdbs }),
    onError: () => toast.error("An error occurred when retrieving the Plant GSDBs (IEO)"),
  });
};

const fetchIeoPlants = async ({ url, plantGsdbs }: FetchIeoPlantsForPlantGsdbsProps) => {
  const { data: ieoPlants } = await axios.post<SelectionListItem<string>[]>(url, plantGsdbs);
  return ieoPlants;
};
